export default __webpack_public_path__ + "static/media/slider_webinar_desktop.4a2661c6.webp";